
import { useNavigate } from 'react-router-dom';
import { MenuItem } from 'primereact/menuitem';
import {Menu} from "primereact/menu";
import React from "react";

function OgMenu() {

    const navigate = useNavigate();

    const items: MenuItem[] = [
        {
            label: 'Organisation',
            icon: 'pi pi-link',
            expanded: true,
            items: [
                {
                    label: 'Organization Account',
                    icon: 'pi pi-building',
                    command: () => navigate('/organisation')
                },
                {
                    label: 'ABAC',
                    icon: 'pi pi-lock',
                    command: () => navigate('/abac')
                }
            ]
        },
        {
            label: 'Objects',
            icon: 'pi pi-palette',
            expanded: true,
            items: [
                {
                    label: 'Generic Objects',
                    icon: 'pi pi-objects-column',
                    command: () => navigate('/generic-objects')
                },
                {
                    label: 'Brands',
                    icon: 'pi pi-tag',
                    command: () => navigate('/brands')
                },
                {
                    label: 'Reviews',
                    icon: 'pi pi-star',
                    command: () => navigate('/reviews')
                },
                /*
                {
                    label: 'Enums',
                    icon: 'pi pi-list',
                    command: () => navigate('/enums')
                }

                 */
            ]
        }
    ];

    return (
        <div>
            <div className="menuHeaderContainer mb-3">
                <img src="/favicon.svg" alt="Objects Grid" className="menuHeaderImage"/>
                <div className="menuHeaderText">OBJECTS GRID</div>
            </div>
            <Menu model={items} className="w-full"/>
        </div>
    );
}

export default OgMenu;